import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { Link } from 'react-router-dom';
import { visualizerActions } from "../../store";
import { generateThumbnail } from '../../Helpers/ThumbHelper';
import styles from './DesignMenu.module.css';
import plus from './assets/plus.svg';

export default function DesignMenu() {
    const dispatch = useDispatch();
    const activePattern = useSelector(state => state.visualizer.activePattern);
    const selectedSlot = useSelector(state => state.visualizer.selectedSlot);
    const selectedSlotProducts = useSelector(state => state.visualizer.selectedSlotProducts);
    
    // Log the active pattern data
    console.log('Active Pattern Data:', activePattern);
    console.log('Pattern warranty attribute:', activePattern?.warranty);
    
    // Create full pattern name combining name and color attributes
    const getFullPatternName = () => {
        if (!activePattern) return 'Pattern';
        
        const name = activePattern.name || activePattern.patternName || '';
        const color = activePattern.color || '';
        
        if (name && color) {
            return `${name} ${color}`;
        } else if (name) {
            return name;
        } else if (color) {
            return color;
        } else {
            return 'Pattern';
        }
    };
    
    const patternName = getFullPatternName();
    
    // Parse color slots from descriptor column
    const getColorSlots = () => {
        if (!activePattern?.descriptor) return ['A'];
        
        const slots = activePattern.descriptor.split(',').map(slot => slot.trim());
        return slots.length > 0 ? slots : ['A'];
    };
    
    const colorSlots = getColorSlots();
    const colorCount = colorSlots.length;
    
    // State for eye visibility
    const [hiddenSlots, setHiddenSlots] = useState(new Set());
    
    const handleSlotClick = (index) => {
        dispatch(visualizerActions.setSelectedSlot(index));
    };
    
    const handleEyeClick = (index, e) => {
        e.stopPropagation(); // Prevent slot selection when clicking eye
        setHiddenSlots(prev => {
            const newSet = new Set(prev);
            if (newSet.has(index)) {
                newSet.delete(index);
            } else {
                newSet.add(index);
            }
            return newSet;
        });
    };

    return (
        <div className={styles.content}>
            <div className={styles.header}>
                <h1>AMTICO LAYING PATTERNS</h1>
            </div>
            
            <div className={styles.patternInfo}>
                <div className={styles.patternTitle}>
                    <h2>{patternName}</h2>
                    <Link to="/" className={styles.selectNewPattern}>Select a New Pattern</Link>
                </div>
                
                <div className={styles.colorInfo}>
                    <span className={styles.colorCount}>{colorCount} Color</span>
                    <a 
                        href={activePattern?.warranty ? `/pdf/${activePattern.warranty}` : '#'} 
                        className={styles.downloadPdf}
                        download={activePattern?.warranty || undefined}
                        onClick={(e) => {
                            if (!activePattern?.warranty) {
                                e.preventDefault();
                                console.warn('No PDF available for this pattern');
                            }
                        }}
                    >
                        Download Order Form
                    </a>
                </div>
                
                <p className={styles.instructions}>
                    Select a color and add it to the pattern. To edit a chosen color, click on the one you want 
                    to change and choose a new color.
                </p>
            </div>

            <div className={styles.colorSlots}>
                {colorSlots.map((slot, index) => {
                    const slotProduct = selectedSlotProducts[index];
                    return (
                        <div 
                            key={slot} 
                            className={`${styles.colorSlot} ${index === selectedSlot ? styles.active : ''}`}
                            onClick={() => handleSlotClick(index)}
                        >
                            <div className={styles.colorBox}>
                                {slotProduct ? (
                                    <img 
                                        src={generateThumbnail(slotProduct.id, slotProduct.specifier, "128", 500, slotProduct.series)}
                                        alt={slotProduct.color}
                                        className={styles.productThumbnail}
                                    />
                                ) : (
                                    <div className={styles.colorPlaceholder}> <img src={plus} className={styles.plusImg} alt="product thumbnail"/></div>
                                )}
                            </div>
                            {slotProduct && (
                                <div className={styles.productName}>
                                    {slotProduct.color || slotProduct.name}
                                </div>
                            )}
                            <div className={styles.slotInfo}>
                                <span className={styles.slotLabel}>{slot}</span>
                                <button 
                                    className={styles.eyeButton}
                                    onClick={(e) => handleEyeClick(index, e)}
                                >
                                    {hiddenSlots.has(index) ? '🙈' : '👁'}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}